// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Y0W-","templateContainer":"_1QtL3","mostUsedBadgeContainer":"_10e2b","defaultTemplateContainer":"_26g-l"};